(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aquaboost-water-map"] && !Shopify.designMode) return;
  try {
    
(function(){
  function loadScript(src){
    return new Promise(function(res, rej){
      var s = document.createElement('script');
      s.src = src; s.defer = true;
      s.onload = res; s.onerror = function(){ rej(new Error('load ' + src)); };
      document.head.appendChild(s);
    });
  }
  function ensureLeaflet(){
    if (window.__abLeafletReady) return window.__abLeafletReady;
    if (window.L && window.L.markerClusterGroup){ window.__abLeafletReady = Promise.resolve(); return window.__abLeafletReady; }
    window.__abLeafletReady = (window.L ? Promise.resolve() : loadScript('https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.js'))
      .then(function(){
        if (window.L && window.L.markerClusterGroup) return;
        return loadScript('https://cdnjs.cloudflare.com/ajax/libs/leaflet.markercluster/1.5.3/leaflet.markercluster.js');
      });
    return window.__abLeafletReady;
  }

  function cssVar(el, name, fallback){
    var v = getComputedStyle(el).getPropertyValue(name).trim();
    return v || fallback;
  }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function typeLabel(t){
    t = t || {};
    if (t.amenity === 'fountain') return 'Díszkút (ivható víz)';
    if (t.man_made === 'water_tap') return 'Vízcsap';
    if (t.amenity === 'watering_place') return 'Itató / vízvételi pont';
    return 'Ivókút / vízvételi pont';
  }
  function centroid(coords){
    var pts = [];
    (function dig(a){ if (typeof a[0] === 'number'){ pts.push(a); } else { a.forEach(dig); } })(coords);
    if (!pts.length) return null;
    var sx = 0, sy = 0;
    pts.forEach(function(p){ sx += p[0]; sy += p[1]; });
    return [sx / pts.length, sy / pts.length];
  }
  function waitGlobal(tries){
    return new Promise(function(res, rej){
      (function check(t){
        if (window.AQUABOOST_FOUNTAINS) return res(window.AQUABOOST_FOUNTAINS);
        if (t <= 0) return rej(new Error('no global'));
        setTimeout(function(){ check(t - 1); }, 150);
      })(tries);
    });
  }

  function dropIcon(fill, stroke){
    return L.divIcon({
      className: 'ab-pin',
      html: '<svg width="28" height="38" viewBox="0 0 28 38" xmlns="http://www.w3.org/2000/svg">'
          + '<path d="M14 1 C14 1 26 14 26 22 A12 12 0 0 1 2 22 C2 14 14 1 14 1 Z" fill="' + fill + '" stroke="' + stroke + '" stroke-width="1.4"/>'
          + '<circle cx="14" cy="20" r="5" fill="#fff"/></svg>',
      iconSize: [28, 38], iconAnchor: [14, 36], popupAnchor: [0, -32]
    });
  }

  function initOne(mapEl){
    var sid = mapEl.getAttribute('data-section');
    var cfgEl = document.getElementById('ab-config-' + sid);
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var shell = document.getElementById('ab-shell-' + sid);

    var primary = cssVar(shell, '--ab-aqua', '#00B4D8');
    var deep    = cssVar(shell, '--ab-deep', '#023E5A');
    var marker  = cssVar(shell, '--ab-marker', '#00B4D8');

    var center = [parseFloat(cfg.center[0]) || 47.4979, parseFloat(cfg.center[1]) || 19.0402];

    var map = L.map(mapEl, { minZoom: 4, maxZoom: 19 }).setView(center, cfg.zoom || 14);
    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
      attribution: '© OpenStreetMap © CARTO', subdomains: 'abcd', maxZoom: 19
    }).addTo(map);

    var cluster = L.markerClusterGroup({ showCoverageOnHover: false, maxClusterRadius: 48 });
    map.addLayer(cluster);
    var ICON = dropIcon(marker, deep);

    var statusEl  = shell.querySelector('[data-ab-status]');
    var statusTxt = shell.querySelector('[data-ab-status-text]');
    var spinEl    = statusEl ? statusEl.querySelector('.ab-spin') : null;
    var countEl   = shell.querySelector('[data-ab-count]');

    function status(msg, spin){ if (!statusEl) return; statusEl.classList.add('is-on'); if (statusTxt) statusTxt.textContent = msg; if (spinEl) spinEl.style.display = spin ? '' : 'none'; }
    function hideStatus(){ if (statusEl) statusEl.classList.remove('is-on'); }
    function setCount(n){ if (countEl) countEl.textContent = n; }

    function addFeature(lat, lng, tags){
      var t = tags || {};
      var title = t.name || 'Ingyenes vízvételi pont';
      var dir = 'https://www.google.com/maps/dir/?api=1&destination=' + lat + ',' + lng;
      var html = '<div class="ab-pop"><span class="ab-pop-title">' + esc(title) + '</span>'
               + '<span class="ab-pop-type">' + typeLabel(t) + '</span>'
               + '<a class="ab-pop-link" href="' + dir + '" target="_blank" rel="noopener">Útvonal ide ↗</a></div>';
      cluster.addLayer(L.marker([lat, lng], { icon: ICON }).bindPopup(html));
    }

    /* ---- Közös vezérlők: helymeghatározás + város-gombok ---- */
    var youMarker = null;
    var locBtn = shell.querySelector('[data-ab-locate]');
    if (locBtn) locBtn.addEventListener('click', function(){
      if (!navigator.geolocation){ status('A böngésződ nem támogatja a helymeghatározást.', false); return; }
      status('Helyzeted keresése…', true);
      navigator.geolocation.getCurrentPosition(function(pos){
        var ll = [pos.coords.latitude, pos.coords.longitude];
        if (youMarker) map.removeLayer(youMarker);
        youMarker = L.circleMarker(ll, { radius: 8, color: deep, weight: 3, fillColor: primary, fillOpacity: 1 }).addTo(map);
        map.setView(ll, 15);
      }, function(){ status('Nem sikerült a helymeghatározás – engedélyezd, vagy válassz várost.', false); }, { enableHighAccuracy: true, timeout: 8000 });
    });
    Array.prototype.forEach.call(shell.querySelectorAll('.ab-chip'), function(c){
      c.addEventListener('click', function(){ map.setView([parseFloat(c.dataset.lat), parseFloat(c.dataset.lng)], 15); });
    });

    /* ---- STATIKUS MÓD ---- */
    if (cfg.dataSource === 'static' && (cfg.geojsonUrl || window.AQUABOOST_FOUNTAINS || true)){
      if (cfg.dataSource === 'static'){
        status('Ivókutak betöltése…', true);
        var src = cfg.geojsonUrl
          ? fetch(cfg.geojsonUrl).then(function(r){ if (!r.ok) throw new Error('geojson ' + r.status); return r.json(); })
          : (window.AQUABOOST_FOUNTAINS ? Promise.resolve(window.AQUABOOST_FOUNTAINS) : waitGlobal(20));
        src.then(function(data){
          var feats = (data && data.features) || [];
          var n = 0;
          feats.forEach(function(f){
            if (!f.geometry) return;
            var ll = f.geometry.type === 'Point' ? f.geometry.coordinates : centroid(f.geometry.coordinates);
            if (!ll) return;
            addFeature(ll[1], ll[0], f.properties);
            n++;
          });
          setCount(n);
          if (n === 0){ status('Nincs betölthető ivókút a fájlban.', false); } else { hideStatus(); }
        }).catch(function(){ status('Nem sikerült betölteni a statikus adatfájlt.', false); });
        return;
      }
    }

    /* ---- ÉLŐ MÓD (Overpass) ---- */
    var controller = null, timer = null;
    function fetchWater(){
      if (map.getZoom() < (cfg.minQueryZoom || 13)){ status('Nagyíts rá egy területre az ivókutak betöltéséhez', false); return; }
      if (controller) controller.abort();
      controller = new AbortController();
      status('Ivókutak betöltése…', true);
      var b = map.getBounds();
      var bbox = b.getSouth() + ',' + b.getWest() + ',' + b.getNorth() + ',' + b.getEast();
      var q = '[out:json][timeout:25];('
        + 'node["amenity"="drinking_water"](' + bbox + ');'
        + 'way["amenity"="drinking_water"](' + bbox + ');'
        + 'node["amenity"="fountain"]["drinking_water"="yes"](' + bbox + ');'
        + 'node["man_made"="water_tap"]["drinking_water"="yes"](' + bbox + ');'
        + 'node["amenity"="watering_place"]["drinking_water"="yes"](' + bbox + ');'
        + ');out center ' + (cfg.maxResults || 800) + ';';
      fetch('https://overpass-api.de/api/interpreter', { method: 'POST', body: 'data=' + encodeURIComponent(q), signal: controller.signal })
        .then(function(r){ if (!r.ok) throw new Error('overpass ' + r.status); return r.json(); })
        .then(function(data){
          cluster.clearLayers();
          var els = (data && data.elements) || [];
          var n = 0;
          els.forEach(function(el){
            var lat = el.lat != null ? el.lat : (el.center && el.center.lat);
            var lng = el.lon != null ? el.lon : (el.center && el.center.lon);
            if (lat == null || lng == null) return;
            addFeature(lat, lng, el.tags);
            n++;
          });
          setCount(n);
          if (n === 0){ status('Ezen a területen nincs rögzített ivókút.', false); } else { hideStatus(); }
        })
        .catch(function(err){ if (err.name === 'AbortError') return; status('A térkép adatforrása épp túlterhelt – próbáld újra pár másodperc múlva.', false); });
    }
    map.on('moveend', function(){ clearTimeout(timer); timer = setTimeout(fetchWater, 650); });
    var searchBtn = shell.querySelector('[data-ab-search]');
    if (searchBtn) searchBtn.addEventListener('click', fetchWater);
    map.whenReady(fetchWater);
  }

  function run(){
    var maps = document.querySelectorAll('[data-ab-map]');
    if (!maps.length) return;
    ensureLeaflet().then(function(){
      Array.prototype.forEach.call(maps, function(m){ if (!m.__abInit){ m.__abInit = true; initOne(m); } });
    }).catch(function(){});
  }

  if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', run); } else { run(); }
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
